import { render, staticRenderFns } from "./BldUniInput.vue?vue&type=template&id=369c3e62&scoped=true&"
import script from "./BldUniInput.vue?vue&type=script&lang=js&"
export * from "./BldUniInput.vue?vue&type=script&lang=js&"
import style0 from "./BldUniInput.vue?vue&type=style&index=0&id=369c3e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369c3e62",
  null
  
)

export default component.exports